export default __webpack_public_path__ + "static/media/grafema_angura_05.443a9d91.jpg";